export function debounce(func, wait, immediate) {
  var timeout
  return function () {
    var context = this,
      args = arguments
    if (immediate && !timeout) func.apply(context, args)
    clearTimeout(timeout)
    timeout = setTimeout(function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }, wait)
  }
}

export function removeElement(el) {
  el.parentNode.removeChild(el)
}

const connection =
  navigator.connection || navigator.mozConnection || navigator.webkitConnection
export const saveData =
  connection &&
  (connection.saveData ||
    (connection.effectiveType &&
      ["slow-2g", "2g", "3g"].includes(connection.effectiveType)))

export const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches
